<template>
    <fieldset>
        <legend tabindex="0" class="question" v-html="data.question"></legend>
        <div v-if="data.notice" class="question-description" v-html="data.notice"></div>
        <ul class="no-bullet radio-list" role="radiogroup">
            <li v-for="(option, i) in data.options" :key="i" class="radio-wrapper">
                <input
                    :id="`input-radio-${i}`"
                    v-model="modelValue"
                    type="radio"
                    :value="option"
                    :name="`question_${data.key}`"
                />
                <label :for="`input-radio-${i}`">{{ option.label }}</label>
            </li>
        </ul>
    </fieldset>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
    modelValue: {
        type: Object,
        default: null,
    },
});

const emit = defineEmits(['update:modelValue']);

const modelValue = defineModel();
</script>

<style lang="scss" scoped>
.question {
    @include rem-typo(20px);
    margin-bottom: 8px;

    @include breakpoint(medium) {
        margin-bottom: 16px;
    }
}
.radio-list {
    margin-bottom: 0;
}
.question-description {
    @include rem-typo(14px);
    margin: 0 0 16px;
    font-style: italic;
}
</style>
